import React, { Component } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { Modal, Button, Spinner } from "react-bootstrap";
import FloatingAddButton from "./common/floatingAddButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { RiDeleteBin2Line } from "react-icons/ri";
import { formatNumber } from "../services/util";
import PageLoading from "./common/pageLoading";
import { getIpV4Pools, deleteIpV4Pool } from "../services/ipv4PoolService";
import { StyledTableCell, StyledTableRow } from "../services/tableStyles";

class IpV4Pools extends Component {
  state = {
    pools: [],
    poolToDelete: {},
    showConfirmModal: false,
    loading: "",
    processing: false,
  };

  constructor() {
    super();
    this.state.loading = true;
  }

  showConfirmModal = (poolToDelete) => {
    this.setState({ showConfirmModal: true, poolToDelete });
  };

  handleClose = () => {
    this.setState({ showConfirmModal: false });
  };

  async populatePools() {
    try {
      const { data: pools } = await getIpV4Pools();
      this.setState({ pools });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

  async componentDidMount() {
    await this.populatePools();
  }

  handleDeletePool = async (poolId) => {
    this.setState({ processing: true });
    const { pools: originalPools } = this.state;

    const pools = originalPools.filter((p) => p._id !== poolId);
    this.setState({ pools, showConfirmModal: false });

    try {
      await deleteIpV4Pool(poolId);
      toast.success("Pool Deleted");
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) toast.error(ex.response.data);
      this.setState({ pools: originalPools });
    }
    this.setState({ processing: false });
  };

  handleLinkToAddPage = () => {
    this.props.history.push("/addipv4pool");
  };

  render() {
    const { pools, poolToDelete, showConfirmModal, loading, processing } = this.state;

    return (
      <Paper elevation={3}>
        <div className="card">
          <div className="card-header main-color-bg">
            <h5>IPv4 Pools</h5>
          </div>
          <div className="card-body">
            <span className="card-text">
              {loading && <PageLoading loading={loading} />}
              {!loading && pools.length === 0 && <span>No IPv4 Pools to Display</span>}
              {!loading && <FloatingAddButton classes="float-right mb-2" onClick={this.handleLinkToAddPage} />}

              {!loading && pools.length > 0 && (
                <TableContainer component={Paper}>
                  <Table aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>Name</StyledTableCell>
                        <StyledTableCell>Network Address</StyledTableCell>
                        <StyledTableCell>Subnet Mask</StyledTableCell>
                        <StyledTableCell>Number of Hosts</StyledTableCell>
                        <StyledTableCell>Type</StyledTableCell>
                        <StyledTableCell>Class</StyledTableCell>
                        <StyledTableCell></StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {pools.map((pool) => (
                        <StyledTableRow key={pool._id}>
                          <StyledTableCell>
                            <Link to={`/ipv4pools/${pool._id}`}>{pool.name}</Link>
                          </StyledTableCell>
                          <StyledTableCell>
                            <kbd>
                              {pool.network}/{pool.cidr}
                            </kbd>
                          </StyledTableCell>
                          <StyledTableCell>
                            <kbd>{pool.subnetMask}</kbd>
                          </StyledTableCell>
                          <StyledTableCell>{formatNumber(pool.hostCount)}</StyledTableCell>
                          <StyledTableCell>{pool.type}</StyledTableCell>
                          <StyledTableCell>{pool.class}</StyledTableCell>
                          <StyledTableCell>
                            <Button
                              onClick={() =>
                                this.showConfirmModal({
                                  _id: pool._id,
                                  name: pool.name,
                                })
                              }
                              variant="danger"
                            >
                              <RiDeleteBin2Line />
                            </Button>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </span>
          </div>
        </div>

        <Modal show={showConfirmModal} size="md" centered onHide={this.handleClose}>
          <Modal.Header closeButton className="bg-danger text-white">
            <Modal.Title>Delete IpV4 Pool</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete the Pool: {poolToDelete.name}?</Modal.Body>

          <Modal.Footer>
            <Button onClick={this.handleClose} variant="secondary">
              No
            </Button>
            <Button
              disabled={processing}
              onClick={() => this.handleDeletePool(poolToDelete._id)}
              type="submit"
              variant="primary"
            >
              {processing && (
                <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
              )}
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </Paper>
    );
  }
}

export default IpV4Pools;
